/**
 * Import SASS so Webpack compiles the necessary css
 */
import '../sass/frontend.scss';

/**
 * JavaScript
 */

(function () {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('.nav-menu-mobile .nav-primary');
  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    toggle.classList.toggle('is-active');
    toggle.parentElement.classList.toggle('is-active');
    menu.classList.toggle('is-active');
  });

  const submenuToggles = document.querySelectorAll(
    '.menu-item-has-children > a'
  );
  let currentSubmenuToggle;
  function resetToggles() {
    submenuToggles.forEach((smToggle) => {
      smToggle.nextElementSibling.classList.remove('is-active');
    });
  }
  submenuToggles.forEach((smToggle) => {
    smToggle.addEventListener('click', (e) => {
      e.preventDefault();
      resetToggles();
      if (currentSubmenuToggle !== e.target) {
        smToggle.nextElementSibling.classList.add('is-active');
        currentSubmenuToggle = e.target;
      } else {
        currentSubmenuToggle = null;
      }
    });
  });

  const birthchart = document.querySelector('.purpose-ai-profile-astrology');
  if(birthchart){
    document.onpaste = function(e){
      let pastedText = undefined;
      if (window.clipboardData && window.clipboardData.getData) { // IE
        pastedText = window.clipboardData.getData('Text');
      } else if (e.clipboardData && e.clipboardData.getData) {
        pastedText = e.clipboardData.getData('text/plain');
      }

      const data = {};
      let lines = pastedText.split(/(\r\n)/);
      lines = lines.filter(e => e !== '\r\n');
      lines.forEach(line => {
        let cells = line.split(/(\t)/);
        cells = cells.filter(e => e !== '\t');
        data[`${cells[0].toLowerCase().replace(' ', '-')}-position`] = cells[1];
        data[`${cells[0].toLowerCase().replace(' ', '-')}-sign`] = cells[2];
        data[`${cells[0].toLowerCase().replace(' ', '-')}-house`] = cells[3];
      });

      Object.entries(data).forEach(([key, value]) => {
        const field = birthchart.querySelector(`*[data-paste-target="${key}"]`);
        field.value = value;
      });
      return false;
    }
  }
}());
